module.exports = __webpack_public_path__ + "static/media/MenuIcon.a39dfcaa.svg";